export default "__VITE_ASSET__BmvRN8de__"